/* unplugin-vue-components disabled */import { render } from "./joinUs.vue?vue&type=template&id=29fbb58a"
import script from "./joinUs.vue?vue&type=script&lang=js"
export * from "./joinUs.vue?vue&type=script&lang=js"

import "./joinUs.vue?vue&type=style&index=0&id=29fbb58a&lang=css"

import exportComponent from "F:\\vue2.0+ vant\\2024年项目集合\\元羿官网项目集合\\元羿中文版本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__